#import "../fragments/drip-sequence-dashboard-fragment.graphql"
#import "../fragments/dashboard-stats-fragment.graphql"

query GetDripSequencesDashboard($input: DashboardInput!) {
    dripsDashboard(input: $input) {
        totalCount
        stats {
            ...DashboardStatsFragment
        }
        recentDrips {
            ...DripSequenceDashboardFragment
        }
    }
}
